// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2_fWD","productName":"Table_productName__Eeg6p"};